<template>
  <div
    v-if="icon"
    class="text-left display-flex flex-row flex-wrap tablet:flex-nowrap flex-items-center margin-bottom-lg tablet:margin-bottom-0"
    style="gap: var(--spacing-md); --link-color: var(--fa-navy); --button-margin-bottom: 0; --button-padding: 0"
  >
    <h1 class="sr-only">Viewing Details for the {{ styling.style }} style of {{ icon.name }}</h1>
    <button
      class="link size-2xl flat copy-button text-nowrap"
      style="--button-color: var(--fa-navy); font-weight: var(--font-weight-bold); --button-hover-color: var(--fa-dk-blue)"
      data-balloon-pos="up"
      :aria-label="justCopied === 'iconId' ? 'Copied' : 'Copy Icon Name'"
      @click="copyId"
    >
      <span class="sr-only">Copy</span>
      {{ icon.name }}
    </button>

    <template v-if="isProIcon">
      <span
        v-if="!isProUser"
        class="tag rounded"
        aria-label="This is a Pro Icon"
        data-balloon-pos="up"
        style="--tag-background: var(--fa-yellow)"
        @click.prevent="clickedProTag()"
      >
        Pro
      </span>

      <span
        v-else
        class="tag rounded"
        aria-label="This is a Pro Icon"
        data-balloon-pos="up"
        style="--tag-background: var(--fa-gravy)"
      >
        Pro
      </span>
    </template>

    <button
      v-if="isShowingLink"
      class="link flat copy-button"
      style="--button-color: var(--fa-gravy); --button-hover-color: var(--fa-dk-blue)"
      data-balloon-pos="up"
      :aria-label="justCopied === 'iconUrl' ? 'Copied' : 'Copy Icon URL'"
      @click="copyUrl"
    >
      <font-awesome-icon
        :icon="$v6.solid.faLinkSimple"
        size="xl"
      />
      <span class="sr-only">Copy {{ icon.name }} URL's</span>
    </button>
  </div>
</template>

<script>
  import startsWith from 'lodash/startsWith'
  import { stylingToQuery } from 'app/views/icons/routing.js'
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'IconNameAndLink',

    mixins: [EventTrackingMixin],

    props: {
      defaultStyles: {
        type: Object
      },
      icon: {
        type: Object
      },
      isProUser: {
        type: Boolean,
        default: false
      },
      isProIcon: {
        type: Boolean,
        required: true
      },
      isUsingModal: {
        type: Boolean,
        required: true
      },
      iconUrl: {
        type: String,
        default: 'https://fontawesome.com/search'
      },
      styling: {
        type: Object
      }
    },

    data() {
      return {
        justCopied: ''
      }
    },

    computed: {
      isShowingLink() {
        return this.styling.style !== 'custom'
      }
    },

    methods: {
      markCopied(what) {
        this.justCopied = what
        setTimeout(() => {
          this.justCopied = null
        }, 2000)
      },

      copyId() {
        this.$clipboard(`${this.icon.name}`)
        this.markCopied('iconId')
        this.$posthog.capture('icon_name_copy_click', {
          context: `${this.iconModalContext(this.isUsingModal)}`,
          icon_name: this.icon.name,
          icon_style: this.styling.style,
          icon_family: this.styling.family
        })
      },

      copyUrl() {
        let name = 'latest.icons.detail'

        if (startsWith(this.$route.name, 'five.')) {
          name = 'five.icons.detail'
        }

        const path = this.$router.resolve({
          params: { icon: this.icon.name },
          name,
          query: stylingToQuery(this.styling)
        }).href

        this.$clipboard(`${window.location.origin}${path}`)

        this.markCopied('iconUrl')
      },

      clickedProTag() {
        this.purchaseFlowEvent('icon_pro_tag_click', {
          context: `${this.iconModalContext(this.isUsingModal)}`,
          icon_name: this.icon.name,
          icon_style: this.styling.style,
          icon_family: this.styling.family
        })

        this.$emit('openProIconModal')
      }
    }
  }
</script>
